export const REPORTING_PATH = 'reporting';
export const REPORTING_CLIENT_PATH = 'reporting-client';
export const REPORTING_TEMPLATE_PAGE = 'reporting-templates-page';
